import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Faq from "../../../components/faq";

//for redux and saga
import { connect } from "react-redux";
import { getfaqs } from "../../../redux/actions";

const FaqBox = (props) => {
  const { getFaqsAction, getfaqsList, loading, error, messages } = props;
  // const [howItWorkData, setHowItWorkData] = useState([])

  console.log("faqs check---", getfaqsList, loading, error, messages);

  React.useEffect(() => {
    // alert('calld')
    fetchData();
  }, []);

  const fetchData = () => {
    // alert("hello")
    getFaqsAction(1);
  };

  return (
    
    <>
    { getfaqsList.length > 0
      ?
    <section className="faqbox-wrap pt-100 pb-70">
    <Container>
        <Row>
            <Col md={12}>
                <h2 className="main-title">Frequently Asked Questions</h2>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <Faq getfaqsList={getfaqsList} />
            </Col>
        </Row>
    </Container>            
    </section>
    :
    <section></section>
  }
  </>
  )
};

//   export default FaqBox;
const mapStateToProps = ({ FAQs }) => {
  // console.log('======', howitwork);
  const { loading, error, messages, getfaqsList } = FAQs;
  return { loading, error, messages, getfaqsList };
};

export default connect(mapStateToProps, {
  getFaqsAction: getfaqs,
})(FaqBox);
